(function () {
  'use strict';

  function initSection(root) {
    if (!root || root.dataset.nrReady === 'true') return;
    root.dataset.nrReady = 'true';

    var search = root.querySelector('[data-nr-search]');
    var filters = root.querySelectorAll('[data-nr-filter]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-nr-card]'));
    var empty = root.querySelector('[data-nr-empty]');
    var modal = root.querySelector('[data-nr-modal]');
    var dialog = root.querySelector('[data-nr-dialog]');
    var overlay = root.querySelector('[data-nr-overlay]');
    var closeBtns = root.querySelectorAll('[data-nr-close]');
    var activeFilter = 'all';
    var lastTrigger = null;
    var isOpen = false;
    var isAnimating = false;
    var closeTimer = null;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function normalize(value) {
      return (value || '')
        .toString()
        .toLocaleLowerCase('tr-TR')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim();
    }

    function applyFilters() {
      var q = normalize(search ? search.value : '');
      var visible = 0;

      cards.forEach(function (card) {
        var city = normalize(card.getAttribute('data-nr-city'));
        var haystack = normalize(card.getAttribute('data-nr-search'));
        var cityOk =
          activeFilter === 'all' ||
          city === activeFilter ||
          (activeFilter === 'diger' && ['istanbul', 'ankara', 'izmir'].indexOf(city) === -1);
        var searchOk = !q || haystack.indexOf(q) !== -1;
        var show = cityOk && searchOk;
        card.hidden = !show;
        if (show) visible += 1;
      });

      if (empty) empty.classList.toggle('is-visible', visible === 0);
    }

    filters.forEach(function (btn) {
      btn.addEventListener('click', function () {
        activeFilter = normalize(btn.getAttribute('data-nr-filter') || 'all');
        filters.forEach(function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        applyFilters();
      });
    });

    if (search) search.addEventListener('input', applyFilters);

    function fillModal(card) {
      var photo = modal.querySelector('[data-nr-m-photo]');
      var placeholder = modal.querySelector('[data-nr-m-placeholder]');
      var name = modal.querySelector('[data-nr-m-name]');
      var clinic = modal.querySelector('[data-nr-m-clinic]');
      var quote = modal.querySelector('[data-nr-m-quote]');
      var actions = modal.querySelector('[data-nr-actions]');

      var src = card.getAttribute('data-nr-photo') || '';
      var doctorName = card.getAttribute('data-nr-name') || '';
      var longMsg = (card.getAttribute('data-nr-long') || '').trim();
      var shortMsg = (card.getAttribute('data-nr-short') || '').trim();
      var message = longMsg || shortMsg;

      if (photo) {
        if (src) {
          photo.hidden = false;
          photo.src = src;
          photo.alt = doctorName;
          if (placeholder) placeholder.hidden = true;
        } else {
          photo.hidden = true;
          photo.removeAttribute('src');
          photo.alt = '';
          if (placeholder) {
            placeholder.hidden = false;
            placeholder.textContent = (doctorName || 'N').charAt(0).toLocaleUpperCase('tr-TR');
          }
        }
      }

      if (name) name.textContent = doctorName;
      if (clinic) clinic.textContent = card.getAttribute('data-nr-clinic') || '';
      if (quote) quote.textContent = message;

      // Liquid'de üretilmiş linkleri klonla (website / instagram / maps bağımsız)
      if (actions) {
        actions.innerHTML = '';
        var source = card.querySelector('[data-nr-links-source]');
        if (source) {
          Array.prototype.forEach.call(source.children, function (child) {
            var clone = child.cloneNode(true);
            clone.addEventListener('click', function (event) {
              event.stopPropagation();
            });
            actions.appendChild(clone);
          });
        }
        if (actions.children.length > 0) {
          actions.hidden = false;
          actions.removeAttribute('hidden');
        } else {
          actions.hidden = true;
          actions.setAttribute('hidden', '');
        }
      }
    }

    if (modal && modal.dataset.nrLinkGuard !== 'true') {
      modal.dataset.nrLinkGuard = 'true';
      modal.addEventListener('click', function (event) {
        if (event.target.closest('a[data-nr-link]')) {
          event.stopPropagation();
        }
      });
    }

    function clearCloseTimer() {
      if (closeTimer) {
        window.clearTimeout(closeTimer);
        closeTimer = null;
      }
    }

    function openModal(card, trigger) {
      if (isAnimating && !isOpen) return;

      clearCloseTimer();
      modal.classList.remove('is-closing');

      // Already open: swap content without stacking modals
      if (isOpen) {
        fillModal(card);
        lastTrigger = trigger || lastTrigger;
        return;
      }

      fillModal(card);
      lastTrigger = trigger || null;
      isOpen = true;
      isAnimating = !reducedMotion;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('nogag-references-lock');

      if (dialog) dialog.focus();

      if (!reducedMotion) {
        window.setTimeout(function () {
          isAnimating = false;
        }, 300);
      } else {
        isAnimating = false;
      }
    }

    function finishClose() {
      modal.classList.remove('is-open', 'is-closing');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('nogag-references-lock');
      isOpen = false;
      isAnimating = false;
      closeTimer = null;
      if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
    }

    function closeModal() {
      if (!isOpen && !modal.classList.contains('is-open')) return;
      if (modal.classList.contains('is-closing')) return;

      clearCloseTimer();

      if (reducedMotion) {
        finishClose();
        return;
      }

      isAnimating = true;
      modal.classList.add('is-closing');
      modal.classList.remove('is-open');
      closeTimer = window.setTimeout(finishClose, 280);
    }

    cards.forEach(function (card) {
      card.setAttribute('tabindex', '0');
      card.setAttribute('role', 'button');

      card.addEventListener('click', function (event) {
        if (event.target.closest('a, button, input, textarea, select, label')) return;
        openModal(card, card);
      });

      card.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          openModal(card, card);
        }
      });
    });

    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        closeModal();
      });
    });

    if (overlay) {
      overlay.addEventListener('click', function () {
        closeModal();
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && (isOpen || modal.classList.contains('is-open'))) {
        closeModal();
      }
    });

    // Theme editor: highlight selected block card
    document.addEventListener('shopify:block:select', function (event) {
      if (!root.contains(event.target)) return;
      cards.forEach(function (c) {
        c.classList.remove('is-selected');
      });
      var selected = event.target.closest('[data-nr-card]') || event.target.querySelector('[data-nr-card]');
      if (selected) {
        selected.classList.add('is-selected');
        selected.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'nearest' });
      }
    });

    document.addEventListener('shopify:block:deselect', function () {
      cards.forEach(function (c) {
        c.classList.remove('is-selected');
      });
    });

    applyFilters();
  }

  function boot() {
    document.querySelectorAll('[data-nogag-references]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section =
      event.target && event.target.querySelector
        ? event.target.querySelector('[data-nogag-references]') ||
          (event.target.matches && event.target.matches('[data-nogag-references]') ? event.target : null)
        : null;
    if (section) {
      section.dataset.nrReady = 'false';
      initSection(section);
    }
  });
})();
